import * as React from 'react';
import AudioPlayer from './AudioPlayer';
import '../assets/animations.css';

import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import removeAndFetchCries, { checkPokemonChangeCries } from '../services/getPokemonCries';
import { styles } from '../assets/styles';
import { Pkmn } from '../data/pkmnList';
import { getDate } from '../services/getDate';
import { getPokemonFromStorageCries } from '../services/getPokemonFromStorage';
import { WinnerLetterCries } from './winnerLetter';
import { PokemonInfoCries } from './pokemonInfo';
import { comparePokemonNames } from '../utils/compares';
import { getPokemonInfoFromStorageCries } from '../services/getPokemonInfoFromStorage';
import PokemonAutocomplete from './pokemonAutoComplete';

export default function InputPokemonsCries() {
  const [pokemonInfoListCries, setPokemonInfoListCries] = useState([]);
  const [searchedPokemonName, setSearchedPokemonName] = useState([]);
  const [inputValueCries, setInputValueCries] = useState('');
  const [submitButton, setSubmitButton] = useState(false);
  const [fetchCountCries, setFetchCountCries] = useState(
    parseInt(localStorage.getItem('fetch_count_cries')) || 0,
  );

  const [randomPokemon, setRandomPokemon] = useState(() => getPokemonFromStorageCries());

  useEffect(() => {
    if (!randomPokemon) {
      removeAndFetchCries(setRandomPokemon);
    }
  }, []);

  checkPokemonChangeCries();

  const {
    hour, minutes, dateString, dayName,
  } = getDate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { query } = e.target.elements;
    const pokemonName = query.value.trim().toLowerCase();

    if (!pokemonName || searchedPokemonName.includes(pokemonName)) {
      return;
    }

    setSubmitButton(true);

    try {
      const response = await fetch(
        `https://pokeapi.co/api/v2/pokemon/${query.value.toLowerCase()}`,
      );
      if (response.ok) {
        const data = await response.json();
        const pokemonInfoCries = {
          id: data.id,
          name: data.name.charAt(0).toUpperCase() + data.name.slice(1),
          sprite: data.sprites.front_default,
        };

        pokemonInfoCries.colorName = comparePokemonNames(pokemonInfoCries.name, randomPokemon.name);

        let storedPokemonInfoList = JSON.parse(localStorage.getItem('pokemonInfoListCries'));
        if (!storedPokemonInfoList) {
          storedPokemonInfoList = [];
        }

        // Agregar el nuevo pokemon a la lista de historial de pokemon
        storedPokemonInfoList.push(pokemonInfoCries);

        // Guardar la lista actualizada de historial de pokemon en el almacenamiento local
        localStorage.setItem('pokemonInfoListCries', JSON.stringify(storedPokemonInfoList));

        // Agregar el nuevo pokemon a la lista de historial de pokemon
        storedPokemonInfoList.push(pokemonInfoCries);

        if (pokemonInfoCries.name === randomPokemon.name) {
          const storedGuesses = JSON.parse(localStorage.getItem('guesses_cries')) || {};

          storedGuesses[pokemonInfoCries.name] = {
            date: dateString,
            hour,
            day: dayName,
            minute: minutes,
          };

          localStorage.setItem('guesses_cries', JSON.stringify(storedGuesses));
        }

        // Guardar la lista actualizada de historial de pokemon en el almacenamiento local
        localStorage.setItem('pokemonInfoListCries', JSON.stringify(storedPokemonInfoList));

        // Agregar el nuevo pokemon a la lista de historial de pokemon
        const lastPokemon = storedPokemonInfoList[storedPokemonInfoList.length - 1];
        if (!lastPokemon || lastPokemon.id !== pokemonInfoCries.id) {
          storedPokemonInfoList.push(pokemonInfoCries);
        }

        // Guardar la lista actualizada de historial de pokemon en el almacenamiento local
        localStorage.setItem('pokemonInfoListCries', JSON.stringify(storedPokemonInfoList));

        setPokemonInfoListCries((prevState) => [pokemonInfoCries, ...prevState]);
        setSearchedPokemonName((prevState) => [...prevState, pokemonName]);
        setInputValueCries('');

        const updateFetchCount = fetchCountCries + 1;
        setFetchCountCries(updateFetchCount);
        localStorage.setItem('fetch_count_cries', JSON.stringify(updateFetchCount));
      } else {
        throw new Error('Error de solicitud');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitButton(false);
    }
  };

  useEffect(() => {
    const pokemonInfoList = getPokemonInfoFromStorageCries();
    if (pokemonInfoList !== null) {
      pokemonInfoList.reverse();
      setPokemonInfoListCries(pokemonInfoList);
    }
  }, []);

  const autoCompleteOptions = Object.keys(Pkmn)
    .map((key) => Pkmn[key])
    .flat()
    .filter((pokemonName) => !searchedPokemonName.includes(pokemonName));

  return (
    <>
      <Box sx={styles.audio}>
        <AudioPlayer />
      </Box>
      <PokemonAutocomplete
        options={autoCompleteOptions}
        value={inputValueCries}
        onSubmit={handleSubmit}
        onChange={(e, value) => setInputValueCries(value)}
        submitButtonDisabled={submitButton}
        loadingSubmit={submitButton}
      />

      {pokemonInfoListCries.map((pokemonInfoCries) => (
        <PokemonInfoCries key={pokemonInfoCries.id} pokemonInfoCries={pokemonInfoCries} />
      ))}

      {pokemonInfoListCries.map((pokemonInfoCries) => (
        <WinnerLetterCries
          key={pokemonInfoCries.id}
          pokemonInfoCries={pokemonInfoCries}
          fetchCountCries={fetchCountCries}
        />
      ))}
    </>
  );
}
